import { render, staticRenderFns } from "./NoMortgagePage.vue?vue&type=template&id=f0262cb8&scoped=true"
import script from "./NoMortgagePage.vue?vue&type=script&lang=js"
export * from "./NoMortgagePage.vue?vue&type=script&lang=js"
import style0 from "./NoMortgagePage.vue?vue&type=style&index=0&id=f0262cb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0262cb8",
  null
  
)

export default component.exports